import { IS_SERVER } from "@shared/constants";

export const universalGetCountry = ctx => {
  if (IS_SERVER) {
    const { req } = ctx;

    return req.meta.initialData.car.country;
  }

  const { store } = ctx;
  const state = store.getState();

  return state.appConfig.car.country;
};
